import { Check } from "lucide-react";
import { SPINE_STEPS } from "@/lib/creatorConstants";

/** Write → Generate → Record → Mix → Master → Export — where am I? */
export default function WorkflowSpine({ active, done = null, compact = false }) {
  const activeIdx = SPINE_STEPS.findIndex((s) => s.key === active);
  // An explicit `done` list is the truth (a song may skip Record/Mix); without one, earlier steps count as done.
  const explicit = Array.isArray(done);
  return (
    <ol data-testid="workflow-spine" className={`flex flex-wrap items-center ${compact ? "gap-1.5" : "gap-2 sm:gap-3"}`}>
      {SPINE_STEPS.map((step, i) => {
        const isDone = explicit ? done.includes(step.key) : activeIdx > -1 && i < activeIdx;
        const isActive = step.key === active;
        return (
          <li key={step.key} className="flex items-center gap-2 sm:gap-3">
            <span
              data-testid={`spine-step-${step.key}`}
              data-state={isActive ? "active" : isDone ? "done" : "todo"}
              className={`flex items-center gap-1.5 rounded-full border px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.16em] transition-colors duration-300 sm:text-[11px] ${
                isActive
                  ? "border-transparent bg-gradient-to-r from-blue-500 to-violet-600 text-white shadow-[0_0_20px_rgba(99,102,241,0.4)]"
                  : isDone
                    ? "border-emerald-400/40 bg-emerald-500/10 text-emerald-200"
                    : "border-white/10 bg-white/[0.03] text-white/45"
              }`}
            >
              {isDone && !isActive ? <Check className="h-3 w-3" /> : <span className="tabular-nums">{i + 1}</span>}
              {step.label}
            </span>
            {i < SPINE_STEPS.length - 1 && <span className={`h-px w-3 sm:w-6 ${isDone ? "bg-emerald-400/50" : "bg-white/10"}`} />}
          </li>
        );
      })}
    </ol>
  );
}
